import React from "react";

// Sample Data to structure the layout
const NUMEROLOGY_DATA = {
  profile: {
    name: "Arjun Malhotra",
    dob: "10th Jan 1997",
  },
  numbers: [
    {
      number: 5,
      label: "Life Path Number",
      description:
        "Independent, ambitious, and pioneering. Natural initiators who thrive when taking charge.",
    },
    {
      number: 20,
      label: "Destiny Number",
      description:
        "Independent, ambitious, and pioneering. Natural initiators who thrive when taking charge.",
    },
    {
      number: 10,
      label: "Soul Urge Number",
      description:
        "Independent, ambitious, and pioneering. Natural initiators who thrive when taking charge.",
    },
  ],
  content: {
    coreTraits:
      "Capricorn is ruled by Saturn, the planet of discipline and responsibility, which makes them ambitious, hardworking, and highly focused on long-term goals. They are natural planners who value structure, tradition, and stability in life.",
    strengths:
      "Capricorn is ruled by Saturn, the planet of discipline and responsibility, which makes them ambitious, hardworking, and highly focused on long-term goals. They are natural planners who value structure, tradition, and stability in life.",
    challenges:
      "Capricorn is ruled by Saturn, the planet of discipline and responsibility, which makes them ambitious, hardworking, and highly focused on long-term goals. They are natural planners who value structure, tradition, and stability in life.",
    luckyDays:
      "Capricorn is ruled by Saturn, the planet of discipline and responsibility, which makes them ambitious, hardworking, and highly focused on long-term goals. They are natural planners who value structure, tradition, and stability in life.",
    vibrationalEnergy:
      "Capricorn is ruled by Saturn, the planet of discipline and responsibility, which makes them ambitious, hardworking, and highly focused on long-term goals. They are natural planners who value structure, tradition, and stability in life.",
    moodFocus:
      "Capricorn is ruled by Saturn, the planet of discipline and responsibility, which makes them ambitious, hardworking, and highly focused on long-term goals. They are natural planners who value structure, tradition, and stability in life.",
  },
};

// Helper component for a content section (e.g., Core Traits, Strengths)
const ContentSection = ({ title, content }) => (
  <div className="mb-8">
    <h2 className="web-h6 text-gray-950 mb-2">{title}</h2>
    <p className="body-md text-gray-600 leading-relaxed text-base">{content}</p>
  </div>
);

// Helper component for the number cards in the sidebar
const NumberCard = ({ number, label, description }) => (
  <div className="text-center flex flex-col gap-[10px]">
    <div className="flex items-center justify-center">
      <span className="web-h4 w-[54px] h-[54px] flex items-center justify-center text-primary-500 bold bg-primary-100 rounded-full">
        {number}
      </span>
    </div>
    <p className="web-h6 text-gray-950 m-0">{label}</p>
    <p className="body-md text-gray-600 !leading-relaxed m-0">{description}</p>
  </div>
);

function Numerology() {
  const { profile, numbers, content } = NUMEROLOGY_DATA;

  return (
    <>
      <section className="py-8 md:py-12">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header and Action Buttons */}
          <div className="flex justify-between items-center mb-6 md:mb-8">
            <h1 className="text-3xl font-bold text-gray-900">Numerology</h1>
            <div className="flex space-x-3">
              <button className="custom-btn custom-btn-secondary">
                Save Report
              </button>
              <button className="custom-btn custom-btn-primary">
                Consult Expert
              </button>
            </div>
          </div>

          {/* Main Content: Two Columns Layout */}
          <div className="flex flex-col lg:flex-row gap-6">
            {/* --- LEFT COLUMN: Detailed Report --- */}
            <div className="lg:w-3/4 bg-white p-[15px] md:p-[20px] rounded-[20px] border border-gray-100">
              {/* Personality Overview */}
              <h2 className="web-h5 text-gray-950 mb-4">
                Personality Overview
              </h2>
              <ContentSection
                title="Core Traits"
                content={content.coreTraits}
              />
              <ContentSection title="Strengths" content={content.strengths} />
              <ContentSection title="Challenges" content={content.challenges} />

              {/* Numerology Guidance */}
              <h2 className="web-h5 text-gray-950 mt-8 mb-4">
                Numerology Guidance
              </h2>
              <ContentSection title="Lucky Days" content={content.luckyDays} />
              <ContentSection
                title="Vibrational Energy"
                content={content.vibrationalEnergy}
              />
              <ContentSection
                title="Mood / Focus Vibes"
                content={content.moodFocus}
              />
            </div>

            {/* --- RIGHT COLUMN: Profile Card (Fixed Width) --- */}
            <div className="lg:w-1/4 flex-shrink-0">
              <div className="text-center bg-primary-50 p-[15px] md:p-[20px] rounded-[20px]">
                {/* Profile Header */}
                <div className="flex justify-between items-start p-[15px] bg-white border border-gray-100 rounded-[10px]">
                  <div className="text-left flex flex-col gap-[5px]">
                    <h3 className="web-h4 text-gray-950">{profile.name}</h3>
                    <p className="body-md text-gray-950">{profile.dob}</p>
                  </div>
                  {/* Edit Icon */}
                  <button className="text-gray-500 hover:text-gray-700 p-1 rounded-full transition-colors" onClick={() => document.getElementById("editDetailsModal").showModal()}>
                    <img src="/images/edit.svg" alt="Edit" />
                  </button>
                </div>

                {/* Numerology Numbers */}
                <div className="space-y-4 pt-4">
                  {numbers.map((item, index) => (
                    <div key={index}>
                      <NumberCard {...item} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <dialog id="editDetailsModal" className="modal">
        <div className="modal-box p-0">
          <form method="dialog">
            <div className="modal-header flex items-start gap-[10px] justify-between border-0 mb-[15px]">
              <div className="modal-head-left flex flex-col gap-[5px]">
                <h3 className="web-h5 semibold">Edit Details</h3>
              </div>
              <button className="">
                <img src="/images/close.svg" alt="close" />
              </button>
            </div>
          </form>

          <div className="modal-body space-y-[15px] pt-0">
            <div className="flex flex-col gap-[10px]">
                <label htmlFor="name" className="web-body-md text-gray-950">Name</label>
                <input type="text" id="name" className="custom-input" placeholder="Enter Name" />
            </div>

            <div className="flex flex-col gap-[10px]">
                <label htmlFor="name" className="web-body-md text-gray-950">Date of Birth</label>
                <input type="date" id="name" className="custom-input" placeholder="Enter Date of Birth" />
            </div>
          </div>

          <div className="modal-footer border-gray-100 flex items-center !justify-end">
            <div className="flex items-center gap-[10px]">
              <button className="custom-btn custom-btn-secondary">
                Cancel
              </button>
              <button className="custom-btn custom-btn-primary">
                Continue
              </button>
            </div>
          </div>
        </div>
      </dialog>
    </>
  );
}

export default Numerology;
